export enum ETimeType {
  day,
  hour,
}
